export class Expertise {
    readonly id: number;
    name: string;
    typePrestation: string;

    constructor(
		options: {
			id?: number;
			name?: string;
			typePrestation?: string;
		} = {}
	) {
		this.id = options.id || 0;
		this.name = options.name || null;
		this.typePrestation = options.typePrestation || null;
	}
}

